import { trace } from 'rytm-helpers'
import Sound from './models/Sound'

const SOUNDS_DIRECTORY_PATH = "/local/assets/2022/sounds"
let sounds = []

const getSound = (path) => {
  let result = null
  // trace("get sound", params.path, "from sounds", sounds)
  sounds.forEach((sndIt) => {
    if (sndIt.path == path) {
      result = sndIt
    }
  })
  if (!result) {
    result = new Sound(path)
    sounds.push(result)
  }
  return result
}

export const playSound = (file, loop = false, params = {}) => {
  const path = SOUNDS_DIRECTORY_PATH + "/" + file
  let snd =  getSound(path)
  if (snd) {
    snd.fadeIn({loop, ...params})
  } else {
    console.warn("Sound not found", path)
  }
}
export const stopSound = (file) => {
  const path = SOUNDS_DIRECTORY_PATH + "/" + file
  let snd =  getSound(path)
  if (snd) {
    snd.fadeOut()
  } else {
    console.warn("Sound not found", path)
  }
}
export const stopAllSounds = () => {
  sounds.forEach((snd) => {
    snd.destroy()
  })
  sounds = []
}